// owned by WP-SEC-UI · English strings of session UX: idle, absolute expiry, last sign-in (shell-ia §11).
// Key path `econic.session.*`; deep-merged by ./index.en.ts with every other area (a duplicate leaf key throws in development).
const sessionEn = {
  econic: {
    session: {
      welcome: "Welcome back.",
      welcomeFirst: "Welcome to ECONIC.",
      lastSignIn: "Last sign-in {{when}} · {{device}}",
      lastSignInAt: "Last sign-in {{when}}",
      firstSignIn: "First sign-in on this account",
      others_one: "1 other session is active",
      others_other: "{{count}} other sessions are active",
      review: "Review",
      dismiss: "Dismiss",
      unknownDevice: "Unknown device",
      idle: {
        title: "Still there?",
        body: "For security, ECONIC signs you out after 30 minutes without activity.",
        countdown: "Signing out in {{time}}",
        stay: "Stay signed in",
        leave: "Sign out now",
        ended: "You were signed out after 30 minutes without activity.",
      },
      absolute: {
        title: "Session ends at {{time}}",
        body: "Your session ends at {{time}}. Save your work; you will need to sign in again.",
        dismiss: "Dismiss",
      },
      otherTab: "Signed out in another tab",
      revoked: "Your session was ended by an administrator or from another device.",
      notice: {
        title: "Account notice",
      },
      secure: "Secure session · password",
      idleIn: "Idle sign-out in {{time}}",
    },
  },
};

export default sessionEn;
